import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class EdgestateLockableModel extends Model {
  @attr('string') name!: string;
  @attr('string') edgestateResourceType!: string;

  @belongsTo('property', { async: false, inverse: null })
  property!: ModelRegistry['property'] | null;

  @belongsTo('multi-unit', { async: false, inverse: null })
  multiUnit!: ModelRegistry['multi-unit'] | null;

  @belongsTo('edgestate-connection', { async: false, inverse: null })
  edgestateConnection!: ModelRegistry['edgestate-connection'];

  @cached
  get resourceType(): string {
    return this.edgestateResourceType.replace(/_/g, ' ');
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'edgestate-lockable': EdgestateLockableModel;
  }
}
